// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2c4Ry","options":"AnswerScale_options__2SaO_","selected":"AnswerScale_selected__1Uyzt"};